import { useCreateModelMutation } from "@/hooks";
import { ModelEditor } from "./model-editor";

export function FormModelCreate({ handleClose }: { handleClose: () => void }) {
  const mutation = useCreateModelMutation();
  return <ModelEditor handleClose={handleClose} save={values => mutation.mutateAsync(values)} isLoading={mutation.isLoading} />;
}
